module.exports = __webpack_public_path__ + "img/soundcloud.8b21d592.svg";